import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  ProdutoConsultaDto,
  ProdutoConsultaSchema,
  ProdutoNFCeDto,
} from "../../../NFCe/NFCe.Dto";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ExtrairConsultaProdutoComando,
  MapearErrosServidor,
  ValidaGtin,
} from "src/hook/Functions";
import { ProdutoFiltrar } from "src/services/Estoque.Service";
import { NFeCadastroItemLoad } from "./NFe.Cadastro.Item.Load";
import { showToast } from "src/componentes";
import { useNavigate } from "react-router-dom";
import { ProdutoCadastroDto } from "src/pages/Privada/Estoque/Produto/Cadastro/ProdutoCadastro.Dto";
import { NFeDto, STORAGENFE_KEY, updateLocal } from "../../NFe.Dto";

export const NFeCadastroItemCode = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [dataProdutoConsulta, setDataProdutoConsulta] = useState<
    ProdutoNFCeDto[]
  >([]);
  const [modalShowConsultaProduto, setModalShowConsultaProduto] =
    useState(false);
  const [descricaoProdutoConsulta, setDescricaoProdutoConsulta] = useState("");
  const nfeItensLoad = NFeCadastroItemLoad();
  const [modalShowPropriedades, setModalShowPropriedades] = useState(false);
  const [produtoPropriedades, setProdutoPropriedades] =
    useState<ProdutoNFCeDto>();
  const [itemIndexPropriedades, setItemIndexPropriedades] = useState<
    number | null
  >(null);
  const [cadastro, setCadastro] = useState<boolean>(false);

  const formProdutoConsulta = useForm<ProdutoConsultaDto>({
    resolver: yupResolver(ProdutoConsultaSchema),
  });

  useEffect(() => {
    if (!cadastro && !loading) {
      const timer = setTimeout(() => {
        formProdutoConsulta.setFocus("nome", { shouldSelect: true });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [cadastro, loading, formProdutoConsulta]);

  const onSubmitProdutoConsulta = async (data: ProdutoConsultaDto) => {
    setLoading(true);

    try {
      const comando = ExtrairConsultaProdutoComando(data.nome);
      if (comando) {
        data.nome = comando.codigoProduto;
      }

      const response = await ProdutoFiltrar(data);
      if (response.data.success) {
        const data = response.data.data;

        data.forEach((item: ProdutoNFCeDto) => {
          item.valorUnitarioComercial =
            comando?.valor ?? item.valorUnitarioComercial;
          item.valorUnitarioTributavel = item.valorUnitarioComercial;
          item.quantidadeComercial = comando?.quantidade ?? 1;
          item.quantidadeTributavel = comando?.quantidade ?? 1;

          item.codigoBarrasTributavel = item.codigoBarras;
          item.unidadeTributavel = item.unidadeComercial;
          item.quantidadeTributavel = item.quantidadeComercial;

          item.indicaTotal = 1;
          item.valorTotal = Number(
            (item.valorUnitarioComercial * item.quantidadeComercial).toFixed(2)
          );
        });

        if (data.length === 0) {
          formProdutoConsulta.setError(
            "nome",
            { message: "Não localizado" },
            { shouldFocus: true }
          );
        } else if (data.length === 1) {
          setDescricaoProdutoConsulta(data[0].nome);
          const produtoNFCe = data[0] as ProdutoNFCeDto;
          nfeItensLoad.setDataProdutoNFe((prevData) => {
            const nextSeq = prevData.length + 1;
            return [
              ...prevData,
              {
                ...produtoNFCe,
                sequencia: produtoNFCe.sequencia || nextSeq,
                index: nextSeq,
              },
            ];
          });
          formProdutoConsulta.setValue("nome", "");
          setTimeout(() => {
            formProdutoConsulta.setFocus("nome", { shouldSelect: true });
          }, 100);
        } else {
          setDataProdutoConsulta(data);
          setModalShowConsultaProduto(true);
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } finally {
      setLoading(false);
    }
  };

  const onHideModalConsultaProduto = () => {
    setModalShowConsultaProduto(false);
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 100);
  };

  const onSelectModalConsultaProduto = (value: ProdutoNFCeDto) => {
    onHideModalConsultaProduto();
    setDescricaoProdutoConsulta(value.nome);
    nfeItensLoad.setDataProdutoNFe((prevData) => {
      const nextSeq = prevData.length + 1;
      return [
        ...prevData,
        {
          ...value,
          sequencia: value.sequencia || nextSeq,
          index: nextSeq,
        },
      ];
    });
    formProdutoConsulta.setValue("nome", "");
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 150);
  };

  const onCancelModalPropriedades = () => {
    setModalShowPropriedades(false);
    setItemIndexPropriedades(null);
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 150);
  };

  const onDeleteModalPropriedades = (value: ProdutoNFCeDto) => {
    if (itemIndexPropriedades !== null && itemIndexPropriedades >= 0) {
      const next = [...nfeItensLoad.dataProdutoNFe];
      next.splice(itemIndexPropriedades, 1);
      nfeItensLoad.setDataProdutoNFe(next);
      updateLocal<NFeDto>(STORAGENFE_KEY, { itens: next });
    } else {
      const next = nfeItensLoad.dataProdutoNFe.filter((item) => item !== value);
      nfeItensLoad.setDataProdutoNFe(next);
      updateLocal<NFeDto>(STORAGENFE_KEY, { itens: next });
    }
    setModalShowPropriedades(false);
    setItemIndexPropriedades(null);
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 150);
  };

  const onConfirmModalPropriedades = (updatedItem: ProdutoNFCeDto) => {
    if (itemIndexPropriedades !== null && itemIndexPropriedades >= 0) {
      const next = [...nfeItensLoad.dataProdutoNFe];
      next[itemIndexPropriedades] = updatedItem;
      nfeItensLoad.setDataProdutoNFe(next);
      updateLocal<NFeDto>(STORAGENFE_KEY, { itens: next });
    }
    setModalShowPropriedades(false);
    setItemIndexPropriedades(null);
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 150);
  };

  const handleClickPropriedades =
    (value: ProdutoNFCeDto, index: number) => () => {
      setModalShowPropriedades(true);
      setProdutoPropriedades(value);
      setItemIndexPropriedades(index);
    };

  const possuiItens = () => {
    return nfeItensLoad.dataProdutoNFe.length > 0;
  };

  const totalNFe = () => {
    const total = nfeItensLoad.dataProdutoNFe.reduce(
      (acc, item) =>
        acc +
        Number(
          (item.valorUnitarioComercial * item.quantidadeComercial).toFixed(2)
        ),
      0
    );
    return Number(total.toFixed(2));
  };
  const handleVoltar = () => () => {
    navigate("../destinooperacao");
  };

  const handleProximo = () => {
    navigate("../pagamento");
  };

  const handleCancelCadastro = () => {
    setCadastro(false);
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 100);
  };

  const handleSuccessCadastro = async (value: ProdutoCadastroDto) => {
    setCadastro(false);
    if (value) {
      const termo =
        value.codigoProduto || value.codigoBarras || value.nome || "";
      if (termo) {
        formProdutoConsulta.setValue("nome", termo);
        await onSubmitProdutoConsulta({ nome: termo });
      }
    }
    setTimeout(() => {
      formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    }, 100);
  };

  const getInitialValueCadastro = ():
    | Partial<ProdutoCadastroDto>
    | undefined => {
    const termo = formProdutoConsulta.getValues("nome");
    if (!termo || termo.trim() === "") return undefined;
    const cleanTermo = termo.trim();
    const comando = ExtrairConsultaProdutoComando(cleanTermo);
    const valorBusca = comando ? comando.codigoProduto : cleanTermo;

    if (ValidaGtin(valorBusca)) {
      return { codigoBarras: valorBusca };
    }
    return { nome: valorBusca };
  };

  return {
    loading,
    descricaoProdutoConsulta,
    formProdutoConsulta,
    onSubmitProdutoConsulta,
    onHideModalConsultaProduto,
    modalShowConsultaProduto,
    dataProdutoConsulta,
    nfeItensLoad,
    onSelectModalConsultaProduto,
    modalShowPropriedades,
    setModalShowPropriedades,
    produtoPropriedades,
    onCancelModalPropriedades,
    onDeleteModalPropriedades,
    onConfirmModalPropriedades,
    handleClickPropriedades,
    possuiItens,
    totalNFe,
    handleVoltar,
    handleProximo,
    cadastro,
    setCadastro,
    handleSuccessCadastro,
    handleCancelCadastro,
    getInitialValueCadastro,
  };
};
